import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

import * as styles from "./style.css";
import { StickerFormatEnum } from "../../../domain/enums/StickerFormatEnum";

class StickersComponentsTryAgainBtn extends PureComponent {

  static defaultProps = {
    withoutFileSelect: false,
    onChange: () => {},
    onPress: () => {}
  };

  static propTypes = {
    withoutFileSelect: PropTypes.bool,
    onChange: PropTypes.func,
    onPress: PropTypes.func,
    format: PropTypes.string
  };

  _renderInput() {
    switch (this.props.format) {
      case StickerFormatEnum.Video:
        return (<input type="file"
                       accept="video/*"
                       onChange={this.props.onChange}
                       capture
                       className={styles.submitInput} />);
      case StickerFormatEnum.Image:
        return (<input type="file"
                       accept="image/*"
                       onChange={this.props.onChange}
                       capture
                       className={styles.submitInput} />);
      case StickerFormatEnum.Upload:
        return (<input type="file"
                       onChange={this.props.onChange}
                       className={styles.submitInput} />);
      case StickerFormatEnum.Audio:
      default:
        return null;
    }
  }

  render() {
    if (this.props.format === StickerFormatEnum.Audio || this.props.withoutFileSelect) {
      return (
        <div onClick={this.props.onPress} className={styles.submitBtn}>
          <span className={styles.submitLabel}>{this.props.t('label')}</span>
        </div>
      );
    }
    return (
      <label className={styles.submitBtn}>
        { this._renderInput()}
        <span className={styles.submitLabel}>
          {this.props.t('label')}
        </span>
      </label>
    );
  }
}

export default withTranslation('cmp-try-again-btn')(StickersComponentsTryAgainBtn);


// WEBPACK FOOTER //
// ./src/app/modules/stickers/ui/components/try-again-btn/index.jsx